import { render } from "./ListEmptyState.vue?vue&type=template&id=16cb6a37"
import script from "./ListEmptyState.vue?vue&type=script&lang=js"
export * from "./ListEmptyState.vue?vue&type=script&lang=js"

import "./ListEmptyState.vue?vue&type=style&index=0&id=16cb6a37&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__